<template>
  <div>
    <section>
      <Arts v-if="id == 'arts-and-culture'" />
      <Beaches v-if="id == 'beaches'" />
      <CivilRights v-if="id == 'civil-rights-legacy'" />
      <Food v-if="id == 'food-and-drink'" />
      <History v-if="id == 'history'" />
      <Music v-if="id == 'music'" />
      <Outdoors v-if="id == 'outdoor'" />
      <Science v-if="id == 'science-and-discovery'" />
      <Sports v-if="id == 'sports'" />
      <Golf v-if="id == 'year-round-golf'" />
    </section>
    <Footer/>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import Footer from '@/components/Common/Footer.vue';
import Arts from '@/components/Experiences/Arts.vue';
import Beaches from '@/components/Experiences/Beaches.vue';
import CivilRights from '@/components/Experiences/CivilRights.vue';
import Food from '@/components/Experiences/Food.vue';
import History from '@/components/Experiences/History.vue';
import Music from '@/components/Experiences/Music.vue';
import Outdoors from '@/components/Experiences/Outdoors.vue';
import Science from '@/components/Experiences/Science.vue';
import Sports from '@/components/Experiences/Sports.vue';
import Golf from '@/components/Experiences/Golf.vue';

@Component({
  components: {
    Arts,
    Beaches,
    CivilRights,
    Food,
    History,
    Music,
    Outdoors,
    Science,
    Sports,
    Golf,
    Footer,
  },
  data() {
    return {};
  },
})
class ExperienceDetail extends Vue {
    @Prop({
      type: [String],
      required: true,
    })
    id;
}

export default ExperienceDetail;
</script>

<style scoped>

</style>
